import React from 'react'
import { StyledIcon } from '../styled'
import { ReactComponent as Icon } from '../assets/min/audio.svg'

const Audio = ({ medium, large }) => (
	<StyledIcon medium={medium} large={large}>
		<Icon />
	</StyledIcon>
)

export default Audio
